import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import RichTextEditor from "@/components/editor/RichTextEditor";
import FieldHint from "@/components/common/FieldHint";
import { inspirationHintRegistry } from "@/lib/webHints/inspiration";
import type { ActivityTabProps } from "./types";

export default function DescriptionTab({ form }: ActivityTabProps) {
  const { t } = useTranslation();
  const { control } = form;

  return (
    <div className="card">
      <h2 className="mb-4 text-lg font-semibold text-gray-900 dark:text-white">
        {t("content.activities.description.title")}
      </h2>
      <Controller
        name="description"
        control={control}
        render={({ field }) => (
          <RichTextEditor
            content={field.value || ""}
            onChange={field.onChange}
            placeholder={t("content.activities.description.placeholder")}
          />
        )}
      />
      <FieldHint registry={inspirationHintRegistry} field="description" variant="inspiration" />
    </div>
  );
}
